const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

export const reformatDate = (str) => {
  return new Date(str).toLocaleDateString('en-GB', options);
};

export const timestampToDate = (timestamp) => {
  return new Date(timestamp * 1000).toLocaleDateString('en-GB', options);
};

/**
 * @param {Array} data arrays of nav
 * @param {String} filter type of docs sucs as { achitecture, tutorials, etc }
 * @returns {Array} array of nav object.
 */
export const navReformat = (data, filter) => {
  try {
    return data.filter(doc => filter === doc.type)
      .map(doc => {
        return { name: doc.topic, url: doc.id };
      });
  } catch (error) {
    console.log(error);
    return [];
  }
};
